export default __webpack_public_path__ + "static/FTRegolaNeue-Light-7f9e255781fc55889713c802d39ee45f.woff";